export default {
  'HOTEL' (state) {
    return state.hotel
  }
}
